var map = {
	"./account.svg": 7478,
	"./agent-1.png": 9518,
	"./agent-2.png": 8293,
	"./alarm.svg": 2964,
	"./alarmw.svg": 3587,
	"./alimentacao-1.png": 1441,
	"./app-store-icon.svg": 5028,
	"./arrow-left.svg": 1110,
	"./awards-black.svg": 7089,
	"./awards-blue.svg": 3100,
	"./awards.svg": 2231,
	"./awardsw.svg": 874,
	"./badge-app-store-black.png": 4578,
	"./badge-play-store-black.png": 8693,
	"./bananas.svg": 3917,
	"./bars-solid.svg": 8209,
	"./bowl-black.svg": 7231,
	"./bowl-blue.svg": 9766,
	"./bowl.svg": 3297,
	"./bowlw.svg": 620,
	"./bread.svg": 3929,
	"./bulb.svg": 7748,
	"./bulbDark.svg": 5928,
	"./bullseye-blue-small.svg": 8243,
	"./bullseye-blue.svg": 3534,
	"./bullseye-gray.svg": 8420,
	"./bullseye-red.svg": 5722,
	"./bullseye-white.svg": 1248,
	"./bullseye.svg": 4800,
	"./change.svg": 2265,
	"./check.svg": 4811,
	"./checkbox-blue.svg": 6979,
	"./checkbox.svg": 4442,
	"./chevron-down-2.svg": 2,
	"./chevron-down.svg": 663,
	"./chevron-down3.svg": 4358,
	"./chevron-left-solid.svg": 5126,
	"./chevron-left.svg": 8248,
	"./chevron-right-solid.svg": 3877,
	"./chevron-right.svg": 5303,
	"./chevron-up-2.svg": 917,
	"./chevron-up.svg": 8808,
	"./chevron-up3.svg": 2475,
	"./comment.svg": 7016,
	"./css-pattern-1.png": 3025,
	"./dots-horizontal.svg": 8602,
	"./eating-1-mobile.png": 6488,
	"./eating-1.png": 8051,
	"./eating-okt-2.png": 1681,
	"./edit.svg": 8529,
	"./exercise-1.png": 6431,
	"./exercise-okt.png": 8416,
	"./familia-1.png": 7808,
	"./family-new.png": 8158,
	"./family.svg": 9781,
	"./fifth-image-home.png": 2506,
	"./fire-blue.svg": 2110,
	"./fire-red.svg": 3691,
	"./fire-white.svg": 7997,
	"./first-image-home.png": 1661,
	"./florence-com-titulo.png": 4913,
	"./florence-darker.png": 1051,
	"./florence-image-text.png": 4187,
	"./florence-text.png": 6215,
	"./florence-white-blue.png": 7342,
	"./food-okt.png": 7594,
	"./forum-1.png": 5510,
	"./forum-2.png": 6717,
	"./forum-black.svg": 5418,
	"./forum-blue.svg": 7937,
	"./forum-home.png": 4906,
	"./forum-okt.png": 825,
	"./forum-screen-2.png": 4382,
	"./fourth-image-home.png": 3251,
	"./fruit.svg": 4949,
	"./google-play-button.png": 7982,
	"./habits-home.png": 6064,
	"./health-1.png": 9867,
	"./health-2-mobile.png": 4121,
	"./health-2.png": 8656,
	"./health-data.png": 7120,
	"./health-home.png": 6101,
	"./health-icon.svg": 7287,
	"./health-okt.png": 3948,
	"./heart-blue.svg": 9572,
	"./heart-white.svg": 1695,
	"./heart.svg": 2543,
	"./home-hero-1.jpg": 1243,
	"./info.svg": 201,
	"./lazy-animal.svg": 7152,
	"./left-arrow-card-2.svg": 2492,
	"./left-arrow-card.svg": 3309,
	"./like-filled.svg": 1873,
	"./like.svg": 6108,
	"./log-out.svg": 9974,
	"./logo-florence.png": 145,
	"./lupa-2.svg": 8436,
	"./lupa.svg": 9093,
	"./meal-black.svg": 1654,
	"./meal.svg": 1980,
	"./noodles.svg": 4399,
	"./paper-clip.svg": 1524,
	"./photo-camera.svg": 1961,
	"./pilates-1.svg": 85,
	"./pilates-10.svg": 31,
	"./pilates-11.svg": 5390,
	"./pilates-2.svg": 3862,
	"./pilates-3.svg": 6663,
	"./pilates-4.svg": 1592,
	"./pilates-5.svg": 7097,
	"./pilates-6.svg": 5162,
	"./pilates-7.svg": 427,
	"./pilates-8.svg": 5452,
	"./pilates-9.svg": 909,
	"./pill-black.svg": 8110,
	"./pill-blue.svg": 4893,
	"./pill.svg": 2820,
	"./pillw.svg": 6035,
	"./play-store-icon.svg": 3503,
	"./plus-blue.svg": 1510,
	"./plus.svg": 1569,
	"./portal-saude-1.png": 4400,
	"./remove.svg": 5169,
	"./right-arrow-card-2.svg": 8985,
	"./right-arrow-card.svg": 9156,
	"./running-black.svg": 7896,
	"./running.svg": 202,
	"./second-1-image-home.png": 7909,
	"./second-2-image-home.png": 7104,
	"./sport-badminton.svg": 8128,
	"./sport-basketball.svg": 4827,
	"./sport-bicycle.svg": 9805,
	"./sport-biker-blue.svg": 3646,
	"./sport-biker.svg": 6009,
	"./sport-bodyboard.svg": 8630,
	"./sport-bowler.svg": 3455,
	"./sport-fisherman.svg": 9235,
	"./sport-football.svg": 4821,
	"./sport-frisbee.svg": 1106,
	"./sport-golf.svg": 6358,
	"./sport-ice-hockey.svg": 1555,
	"./sport-ice-skater.svg": 5696,
	"./sport-lacrosse.svg": 5729,
	"./sport-paddling.svg": 5587,
	"./sport-ping-pong.svg": 2577,
	"./sport-racket.svg": 2236,
	"./sport-skier.svg": 2404,
	"./sport-surfing.svg": 1142,
	"./sport-swimmer.svg": 834,
	"./sport-tennis.svg": 9035,
	"./sport-volleyball.svg": 9730,
	"./sport-waterpolo.svg": 2607,
	"./star_big.svg": 7598,
	"./star_medium.svg": 2889,
	"./star_small.svg": 5385,
	"./sun.svg": 405,
	"./third-image-home.png": 9882,
	"./trophy-blue.svg": 1120,
	"./trophy-red.svg": 5401,
	"./trophy-white.svg": 8195,
	"./trophy.svg": 9075,
	"./tutorial-exercise.png": 4242,
	"./tutorial-food.png": 6384,
	"./tutorial-forum.png": 8961,
	"./tutorial-medication-l.png": 6466,
	"./tutorial-medication-s.png": 5701,
	"./tutorial-medication.png": 2085,
	"./user-circle.svg": 2153,
	"./user-thin.svg": 3820,
	"./watermellow.svg": 3670,
	"./wrap.svg": 9541,
	"./x-solid-black.svg": 1867,
	"./x-solid.svg": 2173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;